import Button from "../../../shared/components/UI/Button"
import styles from '../main.module.scss'; 
import { classNames } from "../../../shared/shared";
import { displayNotImplemented } from "../../../shared/services/Notifications/NotificationServices";

export default function PromoteButtons({actionName, actionRef, detailsText='Подробнее', ...props}) {

    const actionButton = actionName === '#'? null : <Button className={styles["promoteButtons-action"]} onClick={()=>{displayNotImplemented()}} href={actionRef} contrastStyle >{actionName}</Button>

    const className = props.className? styles[props.className] : ''
    return (
        <div className={classNames(styles["promoteButtons"], className)}>
            {actionButton}
            <Button onClick={()=> props.detailsAction? props.detailsAction() : displayNotImplemented()} href={props.detailsAction? null : props.detailsRef} refStyle className={styles["promoteButtons-details"]}><p>{detailsText}</p><div className={styles['promoteButtons-details-arrow']}></div></Button>
        </div>
    )
}
